import { selectWarehouse } from 'containers/Warehouses/warehousesSlice'
import useResignationAction from '../hooks/useResignationAction'
import useResignationData from '../hooks/useResignationData'
import { useReduxDispatch, useReduxSelector } from 'store'
import { getBalance } from 'containers/Login/loginSlice'
import { useHistory, useParams } from 'react-router-dom'
import React, { useEffect, useState } from 'react'
import { Action, Step } from '../core/utils'
import Loading from 'components/Loading'
import Payments from '../core/Payments'
import Camera from '../core/Camera'
import Final from '../core/Final'
import Calendar from './Calendar'
import Summary from './Summary'
import Default from './Default'

interface Params {
  id: string
  action: Action
}

const MagResignation: React.FC = () => {
  const { id, action } = useParams<Params>()
  const warehouse = useReduxSelector(state => selectWarehouse(state, id))

  const [step, setStep] = useState<Step>('init')
  const [deliveries, setDeliveries] = useState<payments.Delivery[]>([])
  const [showCalendar, setShowCalendar] = useState(!warehouse.resignation)
  const [selectedTimePeriods, setSelectedTimePeriods] = useState<payments.SelectedTimePeriods>(0)
  const { response, selectedData, selectData, reload, generateInvoice } = useResignationData('termination', 'finishRenting', deliveries)
  const { isSending, sendResignation } = useResignationAction('termination', selectedData, deliveries, setStep)

  const { goBack } = useHistory()
  const dispatch = useReduxDispatch()

  useEffect(() => {
    dispatch(getBalance())
  }, [dispatch])

  return (
    <div className='menu__section menu__resignation'>
      {(() => {
        switch (step) {
          case 'finish': return <Final />

          case 'payment': return <Payments
            response={response}
            selectedData={selectedData}
            selectedTimePeriods={selectedTimePeriods}
            generateInvoice={generateInvoice}
            setStep={setStep}
            reload={reload}
          />

          default: {
            switch (action) {
              case 'calendar': return <Calendar
                response={response}
                selectedData={selectedData}
                redirect={goBack}
                selectData={(prev: React.SetStateAction<payments.SelectedData>) => {
                  selectData(prev)
                  setSelectedTimePeriods(0)
                }}
              />

              case 'camera': return <Camera
                selectedData={selectedData}
                selectData={selectData}
              />

              case 'summary': return <Summary
                response={response}
                selectedData={selectedData}
                selectedTimePeriods={selectedTimePeriods}
                setSelectedTimePeriods={setSelectedTimePeriods}
                selectData={selectData}
                setStep={setStep}
              />

              default: return response
                ? showCalendar
                  ? <Calendar
                    response={response}
                    selectedData={selectedData}
                    redirect={() => {
                      setShowCalendar(false)
                    }}
                    selectData={(prev: React.SetStateAction<payments.SelectedData>) => {
                      selectData(prev)
                      setSelectedTimePeriods(0)
                    }}
                  />
                  : <Default
                    response={response}
                    isSending={isSending}
                    deliveries={deliveries}
                    selectedData={selectedData}
                    setDeliveries={setDeliveries}
                    sendResignation={sendResignation}
                    selectData={selectData}
                  />
                : <div className='resignation__main'>
                  <Loading middleOfPage />
                </div>
            }
          }
        }
      })()}
    </div>
  )
}

export default MagResignation